<template>
  <modal @modal-close="handleClose">
    <form
      class="bg-white rounded-lg shadow-lg overflow-hidden"
      style="width: 460px"
    >
      <div class="p-8">
        <div v-if="Object.keys(message).length" class="text-center text-80 leading-normal">
          <p>{{ `${message.text}. ${message.advice}` }}</p>
        </div>
      </div>

      <div class="bg-30 px-6 py-3 flex">
        <div class="ml-auto">
          <button
            type="button"
            class="btn text-80 font-normal h-9 px-3 mr-3 btn-link"
            @click.prevent="handleClose"
          >
            {{ $t('Cancel') }}
          </button>
          <button
            id="add-users"
            ref="confirmButton"
            class="btn btn-default btn-danger"
            @click.prevent="handleUpgrade"
          >
            <span v-if="!updating">{{ $t('Add user seats') }}</span>
            <loader v-else />
          </button>
        </div>
      </div>
    </form>
  </modal>
</template>

<script>
  import { fetchUser } from '@/ui/auth/auth';
  import { updateSubscription } from '@/services/api/resources/chargebee/subscription/actions';

  export default {
    name: 'InviteUsersLimitModal',
    props: {
      message: {
        type: Object,
        default: () => {
        },
      },
      user: {
        type: Object,
        default: () => {
        },
      },
      usersToAdd: {
        type: Number,
        default: 0,
      },
      totalUsers: {
        type: Number,
        default: 0,
      },
    },

    data() {
      return {
        updating: false,
      };
    },
    mounted() {
      this.$refs.confirmButton.focus();
    },
    methods: {
      handleClose() {
        this.$emit('close');
      },
      handleSuccessfulUpgrade() {
        fetchUser()().then(() => {
          this.$toasted.show(
            this.$t('Successfully updated seat count!'),
            { type: 'success' },
          );
          this.updating = false;
          this.$emit('updated', true);
          this.handleClose();
        });
      },
      handleUpgradeErrors(e) {
        this.$toasted.show(
          this.$t(e.response.data.message),
          { type: 'error' },
        );
        this.updating = false;
      },
      handleUpgrade() {
        this.updating = true;

        updateSubscription(this.user.subscription.id, this.totalUsers)()
          .then(() => this.handleSuccessfulUpgrade())
          .catch(e => this.handleUpgradeErrors(e));
      },
    },
  };
</script>
